module.exports = __webpack_public_path__ + "static/img/表情.110df1a4.svg";